<template>
    <div>
      <StatusFilter></StatusFilter>
      <div class="filter-row">
          <DateFilter></DateFilter>
          <GroupFilter :groups="groups"></GroupFilter>
          <FullTextSearch></FullTextSearch>
      </div>
    </div>
</template>
<script>
    import StatusFilter from './Filter/StatusFilter';
    import FullTextSearch from  './Filter/FullTextSearch';
    import DateFilter from  './Filter/DateFilter';
    import GroupFilter from  './Filter/GroupFilter';

    export default {
        name: 'Chatfilter',
        props: ['allClientMessages', 'groups'],
        components: {
            StatusFilter,
            FullTextSearch,
            DateFilter,
            GroupFilter
        },
    }
</script>
<style lang="scss">

.multiselect__select:before {
  display: none;
}

.multiselect {
  z-index: 66666;
}

.filter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chatFilter {
  display: flex;
  justify-content: space-between;
  // flex-direction: row;
  height: 100px;

  .filterItem {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    border: 1px solid white;
    background-color: #ebebeb;

    &.clickable {
      cursor: pointer;

      &:hover {
        background-color: #bbbbbb;
        color: #fff;
      }
    }

    &.active {
      background-color: #3b3b3b;
      color: #fff;
    }

    .fa-circle {
      font-size: 10px;

      &.circle-orange {
        color: #ffa500;
      }

      &.circle-darkgrey {
        color: #3b3b3b;
      }
    }
  }

  p {
    margin: 0;
  }

  .fa-filter {
    font-size: 35px;
    align-self: center;
    padding: 0 15px 0 15px;
  }
}

.leftend {
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
}

.rightend {
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
}

.whity {
  background: #fff;
  margin: 0;
}
</style>
